//src/app/features/questionnaires/components/QuestionnaireForm/index.tsx
import useQuestionnaireCurrentStepState from 'app/hooks/useQuestionnaireCurrentStepState';
import useQuestionnaireStepState from 'app/hooks/useQuestionnaireStepState';
import Form from 'Components/Form';
import { useEffect } from 'react';
import { UseFormReturn } from 'react-hook-form';
import renderInput from 'utils/renderInput';
import { useValidateQuestionnaireForm } from '../../edit/TaxQuestionnaire/useValidateQuestionnaire';
import QuestionnaireFooter from '../QuestionnaireFooter';
import { errorToast } from 'Components/Notifications';
export interface QuestionnaireFormProps {
  defautlValues: any;
  validationSchema?: any;
  fields: any;
  className?: string;
  fieldClassName?: string;
  hideFooter?: boolean;
}

function QuestionnaireFormFields({
  className = '',
  fields,
  fieldClassName,
  formState,
  validationSchema,
  getValues,
}: {
  fields: any;
  className?: string;
  fieldClassName?: string;
  validationSchema?: any;
} & UseFormReturn) {
  const { current } = useQuestionnaireStepState();
  const validate = useValidateQuestionnaireForm(
    current!.dotPath,
    getValues(),
    validationSchema,
  );

  const isSubmitted = useQuestionnaireCurrentStepState().isValid;

  Object.keys(formState.errors) &&
    console.log(current!.dotPath, formState.errors);
  useEffect(() => {
    isSubmitted !== undefined && validate();
  }, [JSON.stringify(getValues()), isSubmitted]);

  return (
    <div className={`${className} pb-4 grid gap-y-4`}>
      {fields.map((input: any, i: number) => (
        <div className={fieldClassName ? fieldClassName : 'mb-4'} key={i}>
          {renderInput(input)}
        </div>
      ))}
    </div>
  );
}

export default function QuestionnaireForm({
  defautlValues,
  validationSchema,
  className = '',
  fields,
  fieldClassName,
  hideFooter,
}: QuestionnaireFormProps) {
  const { isValid, path, title } = useQuestionnaireCurrentStepState();
  const { onNext, current } = useQuestionnaireStepState();

  return (
    <Form
      id={path}
      className="p-4 flex flex-col h-full justify-between"
      defaultValues={defautlValues}
      onSubmit={onNext}
      onError={() => {
        // Trigger error notification when validation fails
        errorToast('Please complete all required fields.');
      }}
      validationSchema={validationSchema}
      isValid={isValid}
      validationMode="all"
    >
      {(methods) => (
        <>
          <QuestionnaireFormFields
            {...methods}
            fieldClassName={fieldClassName}
            className={className}
            validationSchema={validationSchema}
            fields={fields}
          />
          {!hideFooter && <QuestionnaireFooter formId={path} />}
        </>
      )}
    </Form>
  );
}
